import React from 'react';
import PropTypes from 'prop-types';

import WidgetContainer from 'components/widget/WidgetContainer';
import PaneCTA from 'components/widget/PaneCTA';
import PackPayments from 'components/PackPayments';
import moment from 'moment';
import { renderPackActions } from 'helpers/packHelpers';
import { FullWidthPaperContent } from './Paper';
import getBoxSizeString from './helpers/getBoxSizeString';

const PackWidget = ({
  className, pack, showPayments, smallCTA, hideBottomSection,
}) => {
  const classes = ['PackWidget', className];

  const heading = {
    Pending: 'Upcoming delivery',
    Processing: 'Processing delivery',
    Dispatched: moment(pack.deliveryDate).isBefore() ? 'Previous delivery' : 'Dispatched delivery',
    Completed: 'Previous delivery',
    Cancelled: 'Skipped delivery',
  };
  const actions = !hideBottomSection && renderPackActions(pack);

  return (
    <WidgetContainer className={classes.filter((c) => !!c).join(' ')} noRoundedCorners>
      <FullWidthPaperContent className="section">
        <PaneCTA
          heading={heading[pack.status]}
          mainTitle={moment(pack.deliveryDate).format('DD MMM YYYY')}
          subTitle={getBoxSizeString(pack.product.packSize, pack.product.hasSolution)}
          small={smallCTA}
          linkProps={{ to: `/orders/${pack.id}` }}
        />
      </FullWidthPaperContent>

      {showPayments && (
        <FullWidthPaperContent className="section">
          <h4>Payments for this delivery</h4>
          <PackPayments payments={pack.payments} packStatus={pack.status} />
        </FullWidthPaperContent>
      )}

      { actions && (
        <FullWidthPaperContent className="section">
          {actions}
        </FullWidthPaperContent>
      )}
    </WidgetContainer>
  );
};

PackWidget.displayName = 'PackWidget';

PackWidget.propTypes = {
  className: PropTypes.string,
  smallCTA: PropTypes.bool,
  pack: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.oneOf([
      'Pending',
      'Processing',
      'Dispatched',
      'Completed',
      'Cancelled',
    ]).isRequired,
    availableActions: PropTypes.arrayOf(PropTypes.string),
    deliveryDate: PropTypes.string.isRequired,
    payments: PropTypes.arrayOf(PropTypes.shape({})),
    product: PropTypes.shape({
      items: PropTypes.arrayOf(PropTypes.shape({})),
      hasSolution: PropTypes.bool,
      packSize: PropTypes.shape({
        boxSize: PropTypes.number.isRequired,
        quantity: PropTypes.number.isRequired,
        numberOfEyes: PropTypes.number.isRequired,
      }).isRequired,
    }).isRequired,
    storeUrl: PropTypes.string.isRequired,
    solution: PropTypes.bool,
    nextPack: PropTypes.shape({}),
    previousPack: PropTypes.shape({}),
  }).isRequired,
  showPayments: PropTypes.bool,
  hideBottomSection: PropTypes.bool,
};

PackWidget.defaultProps = {
  className: null,
  showPayments: false,
  smallCTA: false,
  hideBottomSection: false,
};

export default PackWidget;
